import { useQuery } from '@tanstack/react-query';
import http from '../../../utils/http';


export function useGetProviderPatientsCount() {
  const { data, isLoading, refetch, ...rest } = useQuery({
    queryKey: ["provider patient count"],
    queryFn: async () => {
      const response = await http.get("providers/patients/length");
      return response.data;
    },
    staleTime: 1000 * 60 * 60, // data is stale every 1 hour
    refetchInterval: 1000 * 60 * 60, // refetch every 1 hour
  });
  return {
    getProviderPatientCount: data,
    isLoading,
    refetchProviderPatientCount: refetch,
    ...rest,
  }
}